var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookieIcon = function SvgCookieIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.868a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10 12.868a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 10.868a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.013 6.591c.041-.45-.432-1.021-.884-1.021-2.222 0-4.023-1.791-4.023-4 0-.059.001-.117.004-.176C8.142.66 7.635-.12 6.913.015 2.977.755 0 4.191 0 8.32c0 4.668 3.806 8.451 8.5 8.451 3.9 0 7.188-2.612 8.188-6.174.109-.388-.267-.729-.67-.729a3.009 3.009 0 0 1-3.005-3.277ZM7.106 1.57c0 2.724 2.185 4.93 4.895 4.998a.244.244 0 0 1 .01.013 4.007 4.007 0 0 0 3.55 4.262 7.5 7.5 0 0 1-7.061 4.928C4.352 15.771 1 12.43 1 8.32c0-3.608 2.583-6.624 6.02-7.307a.608.608 0 0 1 .09.338 5.05 5.05 0 0 0-.004.219Z"
  })));
};
export default SvgCookieIcon;